import { GET_OBJECTIVE } from "../actions/types";
const initialState = {
  objectives: [],
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_OBJECTIVE:
      return {
        ...state,
        objectives: payload,
      };
    default:
      return state;
  }
}
